<!-- Render a relative timestamp with optional user name -->
<template>
    <span class="text-no-wrap">
        <span v-if="value" class="timestamp">
            {{ dateOnly ? datestamp(value) : timestamp(value) }}
            <q-tooltip anchor="top middle" self="bottom middle">
                {{ dateOnly ? longDate(value) : longDateTime(value) }}
            </q-tooltip>
        </span>
        <span v-else>{{ placeholder }}</span>
        <span v-if="value && user">{{ $t('by_who', { who: user }) }}</span>
    </span>
</template>

<script setup>
import { datestamp, timestamp, longDate, longDateTime } from 'src/utils/formats.js'

defineProps({
    // A dayjs object or date formatted string
    value: [String, Object],

    // Useful if showing a created by/updated by timestamp
    user: String,

    // Set to true if only displaying date type timestamp
    dateOnly: Boolean,

    // Default text to show when no date value is available
    placeholder: String,
})

</script>

<style>
    .timestamp {
        border-bottom: 1px dotted;
        cursor: help;
    }
</style>
